module.exports = __webpack_public_path__ + "img/cloth_g3_shoe-01.be651796.svg";